import bus from '../connection/checkoutConnection';
import store from '../store';
import {
    cancelPayment,
    completePayment,
    getImages,
    lockPayment,
    lockPosProcessingPayment,
    setPaymentLoading,
    unlockPayment,
    unlockPosProcessingPayment,
    updatePayment,
    updatePayments,
    verifyPayment,
} from './checkout.action';
import checkoutService from './checkout.service';
import integrityCheckService from '@/integrityCheck/integrityCheck.service';

export default () => [
    bus.subscribe('broadcastPayment', (data) =>
        // TODO: parse data
        store.dispatch(updatePayment(checkoutService.transformIncomingPayment(data as any, bus.config.storeGuid ?? '') as any)),
    ),
    bus.subscribe('posBackchannelResultAvailable', (data) =>
        // TODO: parse data
        store.dispatch(updatePayment(checkoutService.transformIncomingPayment(data as any, bus.config.storeGuid ?? '') as any)),
    ),

    bus.subscribe('paymentCompleted', (data) => {
        // TODO: parse data
        store.dispatch(completePayment(data as any));
    }),

    bus.subscribe('paymentCancelled', (data) => {
        // TODO: parse data
        store.dispatch(cancelPayment(data as any));
    }),

    bus.subscribe('paymentVerify', (data) => {
        // TODO: parse data
        store.dispatch(verifyPayment(data as any));
    }),

    bus.subscribe('paymentLock', (data) => {
        // TODO: parse data
        store.dispatch(lockPayment(data as any));
    }),

    bus.subscribe('paymentUnlock', (data) => {
        // TODO: parse data
        store.dispatch(unlockPayment(data as any));
    }),

    bus.subscribe('postProcessingPaymentLock', (data) => {
        // TODO: parse data
        store.dispatch(lockPosProcessingPayment(data as any));
    }),

    bus.subscribe('postProcessingPaymentUnlock', (data) => {
        // TODO: parse data
        store.dispatch(unlockPosProcessingPayment(data as any));
    }),

    bus.subscribe('expressSnapshot', (data) => {
        // TODO: parse data
        store.dispatch(getImages(data as any));
    }),

    bus.subscribe('basketIntegrityCheck', (data: any) => {
        // TODO: parse data
        integrityCheckService.getIntegrityCheckItem.setCache(
            {
                storeGuid: bus.config.storeGuid ?? '',
                paymentRequestGuid: data.paymentRequestGuid,
            },
            data,
        );
    }),

    bus.onConnection(
        () => checkoutService.getPendingRequests(bus.config.storeGuid ?? '').then((data) => store.dispatch(updatePayments(data as any))),
        (loading) => store.dispatch(setPaymentLoading(loading)),
    ),
];
